"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPublicTopics = exports.getPublicTopic = exports.getPublicTopics = exports.deleteTopicRelation = exports.postTopicRelation = exports.putTopicOrganization = exports.putTopicAccessibility = exports.deleteTopicPermission = exports.postTopicPermission = exports.putTopicAction = exports.delTopic = exports.postTopic = exports.putTopic = exports.getTopic = exports.getTopics = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var topicsAuthorizedPath = root_1.lmsAuthorized + '/topics/';
var topicsPublicPath = root_1.lmsPublic + '/topics/';

var getTopics = function getTopics(authentication, queryParameters) {
  return common_1.get(authentication, topicsAuthorizedPath, queryParameters);
};

exports.getTopics = getTopics;

var getTopic = function getTopic(authentication, id) {
  return common_1.get(authentication, topicsAuthorizedPath + id);
};

exports.getTopic = getTopic;

var putTopic = function putTopic(authentication, topic) {
  return common_1.put(authentication, topicsAuthorizedPath + topic.id, topic);
};

exports.putTopic = putTopic;

var postTopic = function postTopic(authentication, pos) {
  return common_1.post(authentication, topicsAuthorizedPath, pos);
};

exports.postTopic = postTopic;

var delTopic = function delTopic(authentication, id) {
  return common_1.del(authentication, topicsAuthorizedPath + id);
};

exports.delTopic = delTopic;

var putTopicAction = function putTopicAction(authentication, id, action, data) {
  return common_1.putSub(authentication, topicsAuthorizedPath, id, action, data);
};

exports.putTopicAction = putTopicAction;

var postTopicPermission = function postTopicPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, topicsAuthorizedPath, id, permission);
};

exports.postTopicPermission = postTopicPermission;

var deleteTopicPermission = function deleteTopicPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, topicsAuthorizedPath, id, permissionId);
};

exports.deleteTopicPermission = deleteTopicPermission;

var putTopicAccessibility = function putTopicAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, topicsAuthorizedPath, id, accessibility);
};

exports.putTopicAccessibility = putTopicAccessibility;

var putTopicOrganization = function putTopicOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, topicsAuthorizedPath, id, organizationId);
};

exports.putTopicOrganization = putTopicOrganization;

var postTopicRelation = function postTopicRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, topicsAuthorizedPath, id, relation);
};

exports.postTopicRelation = postTopicRelation;

var deleteTopicRelation = function deleteTopicRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, topicsAuthorizedPath, id, relationId);
};

exports.deleteTopicRelation = deleteTopicRelation;

var getPublicTopics = function getPublicTopics(authentication, queryParameters) {
  return common_1.get(authentication, topicsPublicPath, queryParameters);
};

exports.getPublicTopics = getPublicTopics;

var getPublicTopic = function getPublicTopic(authentication, id) {
  return common_1.get(authentication, topicsPublicPath + id);
};

exports.getPublicTopic = getPublicTopic;

var searchPublicTopics = function searchPublicTopics(authentication, queryParameters) {
  return common_1.get(authentication, topicsPublicPath + 'search', queryParameters);
};

exports.searchPublicTopics = searchPublicTopics;